import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getProcesosExpediente.php';

export default function getProcesosExpediente({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}